import { Color } from '../../../chess/types'
import { useStoreState } from '../../../store/hooks'
import { PuzzleQuestStatusHeader } from './PuzzleQuestStatusHeader'

type StatusType = 'toMove' | 'correctMove' | 'puzzleSolved' | 'puzzleFailed' | 'hintUsed' | 'solution'

const getStatusType = (
    puzzleState: boolean | null | undefined,
    moveStatus: boolean | null | undefined,
    hint: string | null | undefined,
    showSolution: boolean,
): StatusType => {
    if (showSolution) return 'solution'
    if (hint) return 'hintUsed'
    if (puzzleState === true) return 'puzzleSolved'
    if (puzzleState === false) return 'puzzleFailed'
    if (moveStatus) return 'correctMove'
    return 'toMove'
}

export const StatusHeader = () => {
    const hint = useStoreState((state) => state.puzzleQuestView.hint)
    const moveStatus = useStoreState((state) => state.puzzleQuestView.moveStatus)
    const myColor = useStoreState((state) => state.puzzleQuestView.myColor)
    const puzzleState = useStoreState((state) => state.puzzleQuestView.puzzleState)
    const showSolution = useStoreState((state) => state.puzzleQuestView.showSolution)

    const status = getStatusType(puzzleState, moveStatus, hint, showSolution)

    return (
        <PuzzleQuestStatusHeader status={status} playerColor={myColor === Color.White ? 'white' : 'black'} />
    )
}
